/**
 * Score utility: display helpers and thin wrapper around weekScoreEngine.
 */

import { computeWeekScore } from './weekScoreEngine';

/**
 * Calculate detailed score breakdown for a week (same math as persisted scores).
 * @param {Object} teamData - Team data with draftPicks
 * @param {Array} predictions - Array of prediction objects for the week
 * @param {Object} results - Week results
 * @param {number} weekNumber - Week number
 * @param {number|null} mergeWeek - seasonData.mergeWeek hint
 * @param {Object} scoringRules - League scoring rules
 * @param {Object|null} seasonData - Season data
 * @param {Object|null} seasonContestantsMap - contestantId -> name
 * @returns {Object} Breakdown for UI
 */
export function calculateScoreBreakdown(
  teamData,
  predictions,
  results,
  weekNumber,
  mergeWeek,
  scoringRules,
  seasonData = null,
  seasonContestantsMap = null,
) {
  return computeWeekScore(
    teamData,
    predictions,
    results,
    weekNumber,
    scoringRules,
    seasonData,
    seasonContestantsMap,
    mergeWeek,
  );
}

/**
 * Format score breakdown for display
 * @param {Object} breakdown - Score breakdown object from calculateScoreBreakdown
 * @returns {string}
 */
export function formatScoreBreakdown(breakdown) {
  if (!breakdown) return 'No score data';

  const parts = [];

  if (breakdown.predictionPoints > 0) {
    parts.push(`Prediction points: +${breakdown.predictionPoints}`);
  }

  if (breakdown.survivalPoints > 0) {
    parts.push(`Survival points: +${breakdown.survivalPoints}`);
  }

  if (breakdown.winnerPointsBonus > 0) {
    parts.push(`Winner points: +${breakdown.winnerPointsBonus}`);
  }

  if (breakdown.mergeWeekBonus > 0) {
    parts.push(`Merge week bonus: +${breakdown.mergeWeekBonus}`);
  }

  if (parts.length === 0) {
    return 'No points earned';
  }

  return `${parts.join(', ')}, Total: +${breakdown.total}`;
}
